<template>
  <the-edic-admin-facility-content
    :title-page="$t('account-cms-group.title_page')"
  />
</template>

<script>
export default {
  name: "TheEdicAdminFacilityManageAccountCmsGroupLayout",
};
</script>
<script setup>
import TheEdicAdminFacilityContent from "@/layouts/TheEdicAdminFacilityContent.vue";
</script>
